import { Container, Box, Typography, Divider } from "@mui/material";
import React from "react";
import AppConfig from "../../appConfig";

function CheckoutFooter() {
  return (
    <Box
      component="footer"
      // sx={{
      //   position: "fixed",
      //   bottom: 0,
      //   width: "100%",
      //   bgcolor: (theme) => "white",
      //   zIndex: 1500,
      //   opacity: 1,
      // }}
    >
      <Box align="center" mt={0}>
        <Box mb={3}>
          <Divider />
        </Box>
        <Typography variant="caption" fontWeight={100} mt={3}>
          Powered By
        </Typography>
        <Typography variant="h6" fontWeight={400}>
          <a href="https://laddar.africa" target="_blank" rel="noreferrer">
            <img
              src={`${AppConfig.api_media_url}logos/laddar_logo.png`}
              alt="img"
              width="96px"
            />
          </a>
        </Typography>
      </Box>
    </Box>
  );
}

export default CheckoutFooter;
